import { useLoading } from "@hooks";
import { emailActivationService } from "@services/membership";
import { history } from "@state/utils";
import { useState } from "react";

export default function useEmailActivation() {
	const [activationState, setActivationState] = useState<boolean | null>(
		null
	);
	const [errorMessage, setErrorMessage] = useState(null);

	const { setIsLoading } = useLoading();

	const urlParams = new URLSearchParams(history.location.search);

	const activateUserEmail = async () => {
		const mailkey = urlParams.get("mailkey");
		const username = urlParams.get("username");

		if (!mailkey || !username) {
			throw new Error();
		}

		try {
			setIsLoading(true);
			const response = await emailActivationService.emailActivation(
				mailkey,
				username
			);
			if (response.ok) {
				setActivationState(true);
			}
		} catch (error) {
			setActivationState(false);
			setErrorMessage(error?.error?.message);
		} finally {
			setIsLoading(false);
		}
	};

	return { activateUserEmail, activationState, errorMessage };
}
